import { scrollElementIntoView } from "./useAutoScrollIntoView";

const ALERT_SELECTORS = [
  '[data-auto-scroll-alert="true"]',
  '[role="alert"]',
  ".brix-success",
  ".hr-alert-error",
  ".hr-alert-warning",
  ".bw-alert-error",
  ".stp-error",
  ".esi-rpt__error",
  ".esr__alert",
  ".ai-error-banner",
  ".auth-error",
  ".lc-error",
  ".ec-ferr",
].join(",");

function looksLikeInlineErrorBanner(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (!/^(DIV|P|SPAN)$/.test(el.tagName)) return false;
  const cls = el.className || "";
  if (!/(text-red|text-amber|bg-red-50|bg-amber-50|border-red|border-amber)/.test(cls)) {
    return false;
  }
  const text = (el.textContent || "").trim();
  return text.length > 0 && text.length < 600 && el.children.length <= 2;
}

function isAutoScrollAlert(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (el.dataset.autoScrollAlert === "false") return false;
  if (el.dataset.autoScrollAlert === "true") return true;
  if (el.getAttribute("role") === "alert") return true;
  if (el.classList.contains("hr-alert-error") || el.classList.contains("hr-alert-warning")) {
    return true;
  }
  if (el.matches(ALERT_SELECTORS)) return true;
  return looksLikeInlineErrorBanner(el);
}

function scanNode(node) {
  if (!(node instanceof HTMLElement)) return;
  if (isAutoScrollAlert(node)) scrollElementIntoView(node);
  node.querySelectorAll(ALERT_SELECTORS).forEach((el) => scrollElementIntoView(el));
}

/**
 * After a button/action click, scroll to any alert/error node added to the page.
 * Covers inline alerts on pages that do not use NoticeCard/ErrorAlert/HrAlert.
 */
export function setupAutoScrollAlerts(root) {
  let lastActionAt = 0;

  const markAction = (event) => {
    if (
      event.target.closest(
        'button, [role="button"], input[type="submit"], a.btn, a[role="button"]'
      )
    ) {
      lastActionAt = Date.now();
    }
  };

  const observer = new MutationObserver((mutations) => {
    if (Date.now() - lastActionAt > 2500) return;
    for (const mutation of mutations) {
      if (mutation.type !== "childList") continue;
      for (const node of mutation.addedNodes) {
        scanNode(node);
      }
    }
  });

  document.addEventListener("click", markAction, true);
  observer.observe(root, { childList: true, subtree: true });

  return () => {
    document.removeEventListener("click", markAction, true);
    observer.disconnect();
  };
}
